import React from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import { useGalleryLightbox } from './GalleryLightbox';
import { PHOTOS } from './galleryDemoData';

/* Demo 3 — Living Photo Wall. Rows drift continuously in alternating
   directions; hover pauses the row, click opens the lightbox. */
const ROWS = [
    { order: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], speed: '48s', reverse: false },
    { order: [5, 6, 7, 8, 9, 0, 1, 2, 3, 4], speed: '58s', reverse: true },
    { order: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0], speed: '52s', reverse: false },
];

const GalleryWall = () => {
    const lb = useGalleryLightbox(PHOTOS);

    return (
        <GalleryDemoLayout
            demoLabel="Demo 3"
            kicker="Living Photo Wall"
            title="A Wall That Breathes"
            lead="The photos never stop moving. Hover over any row to pause it, then click a photo to open it full-screen."
        >
            <div className="gwall reveal">
                {ROWS.map((row, r) => (
                    <div className="gwall-row" key={r}>
                        <div
                            className="gwall-track"
                            style={{ animationDuration: row.speed, animationDirection: row.reverse ? 'reverse' : 'normal' }}
                        >
                            {/* rendered twice for a seamless loop */}
                            {[0, 1].map((copy) =>
                                row.order.map((idx) => {
                                    const p = PHOTOS[idx];
                                    return (
                                        <button
                                            type="button"
                                            className="gwall-item"
                                            key={`${r}-${copy}-${idx}`}
                                            onClick={() => lb.open(idx)}
                                            aria-label={`View photo: ${p.cap}`}
                                            tabIndex={copy === 0 ? 0 : -1}
                                            aria-hidden={copy === 1}
                                        >
                                            <img src={p.src} alt={p.cap} loading="lazy" draggable="false" />
                                            <span className="gwall-item__ov"><span>{p.cap}</span></span>
                                        </button>
                                    );
                                })
                            )}
                        </div>
                    </div>
                ))}
            </div>
            {lb.lightbox}
        </GalleryDemoLayout>
    );
};

export default GalleryWall;
